
import { ViewTotal } from "@/utils/views/view-total";
import Vue from "vue";
import AppTotalEditContentWrapper from "./TotalEditContentWrapper.vue";
import { Condition, ConditionPropertyType, Operator } from "@/utils/condition/condition";
import AppTotalEditConditionItem from "./TotalEditConditionItem.vue";

export default Vue.extend({
	data(){
		return {
			toEditCondition: null as null | Condition
		};
	},
	props: {
		currentTab: {
			type: Number,
			required: true
		},
		value: {
			type: Object as ()=>ViewTotal,
			required: true
		},
	},
	computed: {
		propType():ConditionPropertyType{
			return ConditionPropertyType.NUMBER;
		}
	},
	methods: {
		editCondition(i:number){
			if (this.toEditCondition == this.value.Conditions[i]){
				this.toEditCondition = null;
			}else{
				this.toEditCondition = this.value.Conditions[i];
			}
		},
		removeCondition(i:number){
			this.value.Conditions.splice(i, 1);
		},
		addCondition(){
			this.toEditCondition = new Condition();
			this.toEditCondition.Value = "0";
			this.toEditCondition.Operator = Operator.EQ;
			this.value.Conditions.push(this.toEditCondition);
		}
	},
	components: {
		AppTotalEditContentWrapper,
		AppTotalEditConditionItem
	},
	i18nEx: {
		componentPrefix: "components.view-editor"
	}
});
